






































































































import Vue from "vue";
import TopNavItem from "@/components/TopNavLink.vue";
import LinkDropdown from "@/components/LinkDropdown.vue";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import UserProfileDialog from "@/views/UserProfile/UserProfileDialog.vue";
import { Routes } from "@/router/Routes";
import { ModuleTypes } from "@/store/ModuleTypes";
import { bus } from "@/main";
import router from "@/router";
import PlayersAndTeamsSelector from "@/components/PlayerAndTeamsSelector/PlayerAndTeamsSelector.vue";
import { PermissionKeys } from "@/types";

interface Link {
  id: string;
  text?: string;
  icon?: string;
  requiresPlayerOrTeam: boolean;
  usesTeamSelector: boolean;
  name: string;
}

export default Vue.extend({
  name: "TopNav",
  components: {
    PlayersAndTeamsSelector,
    TopNavItem,
    LinkDropdown,
    UserProfileDialog
  },
  props: ["activeItemId", "alertItemIds", "hideItems", "isAcademy"],
  data: () => ({
    open: false,
    userId: null,
    selectorActive: false,
    impersonating: false
  }),
  mounted() {
    this.impersonating = this.$cookies.isKey("X-Impersonate-Token-Active");
  },
  computed: {
    orgId(): string {
      return this.$route.params.orgId;
    },
    teamId(): string {
      return this.$route.params.teamId;
    },
    links(): Link[] {
      return [
        {
          text: "Today",
          name: Routes.TODAY.name,
          id: "today",
          usesTeamSelector: false,
          requiresPlayerOrTeam: false
        },
        {
          text: this.orgId ? "Dashboard" : "Players",
          name:
            this.orgId && this.teamId
              ? Routes.COACH_TEAMS.name
              : this.orgId
              ? Routes.COACH_TEAMS.name
              : Routes.FAN_PLAYERS.name,
          id: this.orgId ? "teams" : "players",
          usesTeamSelector: true,
          requiresPlayerOrTeam: true
        },
        {
          text: "Calendar",
          name: this.orgId
            ? Routes.TEAM_CALENDAR.name
            : Routes.FAN_CALENDAR.name,
          id: "calendar",
          usesTeamSelector: true,
          requiresPlayerOrTeam: true
        },
        {
          text: "Email",
          name: this.orgId ? Routes.TEAM_EMAIL.name : Routes.FAN_EMAIL.name,
          id: "email",
          usesTeamSelector: true,
          requiresPlayerOrTeam: true
        },
        {
          text: "Chat",
          name: Routes.CHAT.name,
          id: "chat",
          usesTeamSelector: true,
          requiresPlayerOrTeam: true
        },
        {
          text: "Payments",
          name: Routes.PAYMENTS.name,
          id: "payments",
          usesTeamSelector: true,
          requiresPlayerOrTeam: true
        },
        ...(!this.orgId || (this.org && this.org.academyEnabled)
          ? [
              {
                text: "Academy",
                name: !this.orgId
                  ? Routes.ACADEMY.name
                  : Routes.ACADEMY_ASSIGNMENT_ORGANIZATION.name,
                id: "academy",
                usesTeamSelector: true,
                requiresPlayerOrTeam: true
              }
            ]
          : []),
        ...(this.org &&
        this.org.customRegistrationEnabled &&
        this.hasPermission(PermissionKeys.CAN_MANAGE_REGISTRATION)
          ? [
              {
                text: "Registration",
                name: Routes.CREATE_REGISTRATION.name,
                id: "registration",
                usesTeamSelector: true,
                requiresPlayerOrTeam: true
              }
            ]
          : [])
      ];
    },
    displayLink(): (requiresPlayerOrTeam: boolean) => boolean {
      return requiresPlayerOrTeam =>
        !requiresPlayerOrTeam || (requiresPlayerOrTeam && this.showNav);
    },
    activeLink(): Link | undefined {
      return this.links.find(link => this.$route.path.includes(link.id));
    },
    showPlayerAndTeamSelector(): boolean {
      return this.playersAndTeams.organizations.length > 0;
    },
    // ...mapGetters(["userIsTeambotAdmin"]),
    ...mapGetters(ModuleTypes.AUTH, ["userRoles"]),
    ...mapGetters({
      user: GetterTypes.GET_USER,
      userIsTeambotAdmin: GetterTypes.GET_USER_IS_TEAMBOT_ADMIN,
      showNav: GetterTypes.GET_SHOW_NAVIGATION,
      navNotifications: GetterTypes.GET_NAV_NOTIFICATIONS,
      org: GetterTypes.GET_ORGANIZATION,
      playersAndTeams: GetterTypes.GET_PLAYERS_AND_TEAMS,
      hasPermission: GetterTypes.GET_COACH_HAS_PERMISSION
    })
  },
  methods: {
    isActive(link: Link) {
      return this.$route.path.includes(link.id) && !this.selectorActive;
    },
    navigate(link: Link): void {
      this.open = false;
      this.$router
        .push({
          name: link.name,
          params: {
            orgId: this.orgId,
            teamId: this.teamId
          }
        })
        .catch(() => {});
      return;
    },
    createOrganization() {
      router.push("/subscriptions/signup");
    },
    redirectToHome() {
      this.open = false;
      router
        .push({
          name: Routes.TODAY.name
        })
        .catch(err => {});
    },
    loadIframe() {
      bus.$emit("loadIframe", {
        url: `/user/edit/${this.user.id}?hideNav=true`,
        title: `User Profile`
      });
    },
    getAccountLinks() {
      const acLinks: any[] = [
        // {
        //   text: "Profile",
        //   callback: () => (this.userId = this.user.id),
        //   id: "profile"
        // },
        {
          text: "Create New Organization",
          callback: () => this.createOrganization(),
          id: "createOrg"
        },
        {
          text: "Contact Us",
          callback: () => window.open("mailto:support@goteambot.com"),
          id: "help"
        },
        // ...(!isUserRole(this.userRoles) || isOrgParentRole(this.userRoles)
        //   ? [
        //       {
        //         text: i18n.tc("top_nav.registration"),
        //         href: Routes.CREATE_REGISTRATION.path,
        //         id: "createRegistration"
        //       }
        //     ]
        //   : []),
        // ...(isOrgAdminRole(this.userRoles) && this.org?.enableAcademy
        //   ? [
        //       {
        //         text: "TeamBot Academy",
        //         href: Routes.ACADEMY.path,
        //         id: "teambotAcademy"
        //       }
        //     ]
        //   : []),
        // ...(isOrgAdminRole(this.userRoles) && this.org?.enableRegistration
        //   ? [
        //       {
        //         text: "Registration",
        //         href: "#",
        //         id: "registration"
        //       }
        //     ]
        //   : []),
        {
          text: "Logout",
          href: `/logout`,
          id: "profile"
        }
      ];

      if (this.impersonating) {
        acLinks.push({
          text: "Stop Impersonating",
          callback: () => {
            window.location.href = "/user/index";
          },
          id: "stop-impersonating"
        });
      }

      const teambotAdminLinks = [
        {
          text: "Users",
          href: "/user/index",
          id: "admin-user"
        },
        {
          text: "Reports",
          href: "/admin/reports/stats",
          id: "admin-stats"
        },
        {
          text: "Mandrill",
          href: "/admin/mandrill",
          id: "admin-mandrill"
        }
      ];

      return this.userIsTeambotAdmin
        ? teambotAdminLinks.concat(acLinks)
        : acLinks;
    },
    executeLink(item: any) {
      if (item.href) {
        window.location.href = item.href;
      } else if (item.callback) {
        item.callback();
      }
    },
    selectorUpdate(e: boolean) {
      this.selectorActive = e;
      this.open = e;
    }
  }
});
